import { z } from "zod";

export const schema = z.object({
  firstName: z.string().trim().min(1),
  lastName: z.string().trim().min(1),
  birthDate: z.string().nullable(),
  phone: z.string(),
});

export type FormData = z.infer<typeof schema>;
